app.service('basketServicesModal', function (basketServices, modal) {
	let $modal, $allServices, $allProductServices, $service, $confirm, $serviceControls, $serviceInput, $serviceCheckbox, $serviceDetails;
	let max, quantity, mainItemId, plu, excluded, actionOnClick;
	let variant;
	function changeStage() {
		if (variant == 'service-modal') {
			if (basketServices.isAnyModalServiceChanged()) {
				$confirm.removeAttr('disabled');
			} else {
				$confirm.prop('disabled', true);
			}
		} else { // service-reminder or service-unavailable
			if ($('.js-service-item[data-status="added"]', $modal).length) {
				$confirm.removeAttr('disabled');
			} else {
				$confirm.prop('disabled', true);
			}
		}
	}
	function setElements(service, product) {
		if (modal.isOpen('modal-basket-service')) {
			$modal = $('#modal-basket-service');
			variant = 'service-modal';
		} else if (modal.isOpen('modal-delivery-unavailable')) {
			$modal = $('#modal-delivery-unavailable');
			variant = 'service-unavailable';
		} else {
			$modal = $('#modal-service-to-add-reminder');
			variant = 'service-reminder';
		}
		$allServices = $('.js-service-item', $modal);
		$allProductServices = $allServices.filter('[data-product="' + product + '"]');
		$service = $allProductServices.filter('[data-service="' + service + '"]');
		$serviceInput = $('.js-service-quantity', $service);
		$serviceControls = $('.service-controls', $service);
		$serviceCheckbox = $('input:checkbox', $service);
		$confirm = variant == 'service-modal' ? $('.js-service-change-confirm', $modal) : $('.js-add-services', $modal);
		max = $serviceInput.data('max') / 1;
		quantity = $serviceInput.data('quantity') / 1;
		mainItemId = $serviceInput.data('main-item');
		plu = $serviceInput.data('plu');
		excluded = $serviceCheckbox.data('excluded-services-group');
		actionOnClick = $serviceCheckbox.data('action-on-click');
		//powyższe oznacza że wszystkie usługi na tym modalu są tylko do jednokrotnego wyboru i nie można ich łączyć z innymi usługami
	}
	function inputChange(service, product) {
		setElements(service, product);
		const value = parseInt($serviceInput.val());
		setQuantity(value, service, product);
		changeStage();
	}
	function setQuantity(v, service, product) {
		let value = parseInt(v);

		if (value >= 1 && value <= max) {
			// jest ok
		} else if (value > max) {
			value = max;
		} else {
			value = quantity;
		}
		if (value == 1) {
			$serviceControls.attr('data-status', 'min');
		} else if (value == max) {
			$serviceControls.attr('data-status', 'max');
		} else {
			$serviceControls.attr('data-status', '');
		}
		const productQuantity = $serviceInput.data('product-quantity');
		$serviceControls.attr('data-show-message', productQuantity > 1 && value < max);
		if ($serviceInput.val() != value) {
			$serviceInput.val(value);
			basketServices.setModalServiceStateChange({
				service,
				product,
				newQuantity: value
			});
		}
	}
	function decrease(service, product) {
		setElements(service, product);
		const value = parseInt($serviceInput.val()) - 1;
		setQuantity(value, service, product);
		changeStage();
	}
	function increase(service, product) {
		setElements(service, product);
		const value = parseInt($serviceInput.val()) + 1;
		setQuantity(value, service, product);
		changeStage();
	}
	function add(service, product) {
		setElements(service, product);
		$serviceCheckbox.prop('checked', true);
		if (excluded) {
			$allProductServices.filter('[data-excluded-services-group="' + excluded + '"]').not($service).attr('data-status', 'change').find('input:checkbox').prop('checked', false);
		}
		$service.attr('data-status', 'added');
		if (actionOnClick) {
			basketServices.save();
		}
		basketServices.setModalServiceStateChange({
			service,
			product,
			newStatus: 'added'
		});
		changeStage();
	}
	function change(service, product) {
		add(service, product);
	}
	function remove(service, product) {
		setElements(service, product);
		$serviceCheckbox.prop('checked', false);
		if (excluded) {
			$allProductServices.filter('[data-excluded-services-group="' + excluded + '"]').not($service).attr('data-status', '').find('input:checkbox').prop('checked', false);
		}
		$service.attr('data-status', '');
		if (actionOnClick) {
			basketServices.save();
		}
		basketServices.setModalServiceStateChange({
			service,
			product,
			newStatus: ''
		});
		changeStage();
	}
	function showDetails(service, product) {
		setElements(service, product);
		const $allDescriptions = $('.service-description', $modal).removeClass('active');
		const $serviceToShow = $allDescriptions.filter('[data-service="' + service + '"][data-main="' + product + '"]').first();
		if ($serviceToShow.length) {
			$serviceToShow.addClass('active');
		} else {
			console.log('Brak opisu dla usługi ' + service + ' dla produktu ' + product);
		}
		modal.showInternal();
	}
	function toggleServices(product) {
		setElements(null, product);
		const visibleCount = $allProductServices.filter(':visible').length;
		$allProductServices.closest('.product-item').toggleClass('show-all-services');
		$allProductServices.eq(visibleCount).find('button:visible').first().focus();
	}

	return {
		inputChange,
		decrease,
		increase,
		add,
		change,
		remove,
		showDetails,
		toggleServices
	};
});
